import { IntercomDataTargetNames } from './intercomDataTargetNames';

/**
 * a div component that wraps children with a data-intercom-target attribute
 */

interface IntercomDataTargetProps {
  children: React.ReactNode;
  target: IntercomDataTargetNames;
  targetCondition?: boolean;
  className?: string;
}

const IntercomDataTarget = ({ children, className, target, targetCondition = true }: IntercomDataTargetProps) => {
  // If the condition is explicitly false (because condition is optional), return the children without the data-intercom-target attribute
  if (targetCondition === false) {
    return <div {...(className && { className })}>{children}</div>;
  }

  return (
    <div data-intercom-target={target} {...(className && { className })}>
      {children}
    </div>
  );
};

export default IntercomDataTarget;
